<template>
<Layout>
  <div v-for="(content, i) in primaryNavContent" v-if="el.is.tabletUp">
    <component
      v-if="content.component !== null"
      :is="content.component"
      :isEmbed="isEmbed"
      :onTabletUp="el.is.tabletUp"
      :data="content.data"
      :deepLink="content.deepLink"
      @drawerComponentDataChanged="onComponentDataChanged"
    />
  </div>
</Layout>
</template>

<script>
import utils from '@src/utils/utils';
import Layout from 'layouts/embedPublic';
import PlanGrid from 'PlanGrid/PlanGrid';
import { breakpointsMixin } from 'breakpointsMixin';
import { gtmMixin } from 'gtmMixin';
import { shareMixin } from 'shareMixin';
import PlanMealtimeIcons from 'PlanGrid/PlanMealtimeIcons';
import Favorites from 'Favorites/Favorites';
import Recipes from 'Recipes/Recipes';
import MealDetailFull from 'MealDetail/MealDetailFull';
import Plans from 'Plans/Plans';
import RecipeDetailPublic from 'RecipeDetail/RecipeDetailPublic';
import RecipeDetailFull from 'RecipeDetail/RecipeDetailFull';
import PlanSummary from 'Plans/PlanSummary';
import {
  authComputed,
  dishesMethods,
  errorsComputed,
  favoritesMethods,
  groceryListComputed,
  groceryListMethods,
  kitchenDrawerComputed,
  kitchenDrawerMethods,
  mainComputed,
  mainMethods,
  platelistMethods,
  planComputed,
  planMethods,
  primaryNavMethods,
  primaryNavComputed,
  profileMethods,
  recipesComputed,
  recipesMethods,
} from '@state/helpers';

export default {
  mixins: [breakpointsMixin, gtmMixin, shareMixin],
  components: {
    Favorites,
    Layout,
    MealDetailFull,
    PlanGrid,
    Plans,
    PlanSummary,
    PlanMealtimeIcons,
    Recipes,
    RecipeDetailPublic,
    RecipeDetailFull,
  },
  props: {
    isEmbed: {
      type: Boolean,
      required: true,
    },
    user: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      componentKey: 0,
    };
  },
  page() {
    return {};
  },
  computed: {
    ...authComputed,
    ...kitchenDrawerComputed,
    ...mainComputed,
    ...primaryNavComputed,
    ...recipesComputed,
    currentPrimaryView() {
      return this.primaryNavContent[this.activePrimaryNavIndex];
    },
  },
  async mounted() {
    branch.data((err, data) => {
      if (data) {
        if (data.data_parsed.plateListId) {
          this.handleBranchPlatelistLink(data.data_parsed.plateListId);
        } else if (data.data_parsed.RecipeshareRecipeId) {
          this.handleBranchRecipeLink(data.data_parsed.RecipeshareRecipeId);
        }
      } else if (err) {
        console.log('Branch data error: ', err);
      }
    });

    let deepLinkParts = null;

    if (Object.keys(this.$route.params).length || Object.keys(this.$route.query).length) {
      deepLinkParts = utils.splitWithRemainder(Object.keys(this.$route.params).length ? this.$route.params.deepLink : this.$route.query.deepLink, '/', 1);
    }

    setTimeout(() => {
      if (deepLinkParts && deepLinkParts.length > 0) {
        this.toggleDrawer();
        switch (deepLinkParts[0].toLowerCase()) {
          case 'all-recipes':
            let dishId = null;

            if (deepLinkParts[1]) {
              dishId = parseInt(utils.splitWithRemainder(deepLinkParts[1], '/', 0)[0].replace(/\//g, ''));
            }

            if (!dishId) {
              window.history.replaceState(null, '', window.location.pathname);
              return;
            }

            this.navigateDeeper({
              title: 'All Recipes',
              component: 'Recipes',
              deepLink: deepLinkParts[1],
              context: this.el.is.tabletUp ? 'drawerModal' : null,
            });
            break;
          case 'plans':
            this.navigateDeeper({
              title: 'Plans',
              component: 'Plans',
              deepLink: deepLinkParts[1],
              context: 'drawerModal',
            });
            break;
        }
      }
    });
  },
  methods: {
    ...dishesMethods,
    ...kitchenDrawerMethods,
    ...mainMethods,
    ...platelistMethods,
    ...primaryNavMethods,
    ...recipesMethods,
    async handleBranchPlatelistLink(platelistId) {
      const plate = await this.getPublicPlatelistSummary(platelistId);
      const component = this.loggedIn ? 'PlanDetail' : 'PlanDetailPublic';

      this.navigateDeeper({
        title: this.$t('lblPlanDetails'),
        component: component,
        data: plate,
      });

      if (!this.isOpen) {
        this.toggleDrawer();
      }

      this.updateShareableUrl(component, plate);
    },
    async handleBranchRecipeLink(dishId) {
      const recipeData = await this.getPublicRecipe(dishId);

      this.navigateDeeper({
        title: this.$t('lblRecipe'),
        component: 'RecipeDetailPublic',
        data: recipeData,
        context: this.onTabletUp ? 'drawerModal' : null,
      });

      if (!this.isOpen) {
        this.toggleDrawer();
      }

      this.updateShareableUrl('RecipeDetailPublic', recipeData);
    },
    onComponentDataChanged(newData) {
      // update the currentPrimaryViews data...
      // 1) spread the old data out into a new object
      // 2) spread the newData and let it overwrite any props that need to be updated.
      this.currentPrimaryView.data = {
        ...this.currentPrimaryView.data,
        ...newData,
      };
    },
  },
  watch: {
    primaryNavContent(content) {
      if (content.length > 1) {
        const lastItemIndex = content.length - 1;
        if (content[0].primary) {
          content.shift();
        } else if (content[lastItemIndex].primary) {
          content.splice(0, lastItemIndex);
        }
      }
    },
    navContent(content) {
      if (content.length > 1) {
        if ((this.el.is.tabletUp && content[0].component === null) || content[0].component === 'KitchenDrawerNav') {
          content.shift();
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'theme.scss';
</style>
